import { Client } from "./_clientService";
import { downloadBlob } from "utils/downloadBlob";

async function getLeagues(options: any) {
  try {
    let payload = {
      pageNo: options?.pageNo,
      limit: options?.pageSize,
      sortKey: "createdAt",
      sortDir: "ASC",
      search: options?.searchValue,
      skipPagination: options?.skipPagination ?? false,
    };

    let path = "/league/list";
    const resp = await new Client({ path, payload }).post();

    return resp;
  } catch (error) {
    throw error;
  }
}

function leagueInfo(leagueId: any) {
  try {
    const resp = new Client({
      path: "/league/info",
      payload: {
        leagueConfigId: leagueId,
      },
    }).post();
    return resp;
  } catch (error) {
    throw error;
  }
}

function createLeagueAndMileStone(leagueDetails: any) {
  try {
    const resp = new Client({
      path: "/league/create",
      payload: leagueDetails,
    }).post();
    return resp;
  } catch (error) {
    throw error;
  }
}

function updateLeagueAndMileStone(leagueDetails: any, leagueId: any) {
  try {
    const resp = new Client({
      path: "/league/update",
      payload: { ...leagueDetails, _id: leagueId },
    }).patch();
    return resp;
  } catch (error) {
    throw error;
  }
}

async function validateLeagueBulkUpload(file: File) {
  const formData = new FormData();
  formData.append("file", file);
  const resp = await new Client({
    path: "/league/bulk/validate",
    payload: formData,
    isFormData: true,
  }).post();
  return resp;
}

async function bulkUpdateLeagueConfig(file: File) {
  const formData = new FormData();
  formData.append("file", file);
  const resp = await new Client({
    path: "/league/bulk/update",
    payload: formData,
    isFormData: true,
  }).post();
  return resp;
}

async function downloadLeagueBulkTemplate() {
  await downloadBlob(
    "/league/bulk/template",
    "Bulk-Update-Leagues-Template.xlsx",
  );
}

export {
  getLeagues,
  leagueInfo,
  createLeagueAndMileStone,
  updateLeagueAndMileStone,
  validateLeagueBulkUpload,
  bulkUpdateLeagueConfig,
  downloadLeagueBulkTemplate,
};
